import { render, staticRenderFns } from "./cultureMatrix.vue?vue&type=template&id=3b3d044d&scoped=true"
import script from "./cultureMatrix.vue?vue&type=script&lang=js"
export * from "./cultureMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3d044d",
  null
  
)

export default component.exports